import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTabs',
  setup(__props) {

const mobileArrows = computed(() => !process.env.IS_MANAGER_MODE)
const outsideArrows = computed(() => !process.env.IS_MANAGER_MODE)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_tabs = _resolveComponent("q-tabs")!

  return (_openBlock(), _createBlock(_component_q_tabs, _mergeProps(_ctx.$attrs, {
    align: "justify",
    class: "sfx-tabs",
    "mobile-arrows": mobileArrows.value,
    "outside-arrows": outsideArrows.value
  }), _createSlots({ _: 2 }, [
    (_ctx.$slots.default)
      ? {
          name: "default",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["mobile-arrows", "outside-arrows"]))
}
}

})